import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import * as Icon from "@phosphor-icons/react";

import styles from "./topbar.css";
import "./../../../../Styles/site.css";

function TopBar() {    
    const [userName, setUserName] = useState("");

    useEffect(init, []);
    useEffect(getUserName, []);

    const inputEl = useRef(null);

    function init() {
        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        }
    }

    function getUserName() {
        $.ajax({
            url: "/account/getusername",
            method: "GET",
            contentType: "application/json; charset=utf-8",
        })
        .done((response, textStatus, xhr) => {
            if (textStatus === "success") {
                setUserName(response);
            }
        })
        .fail((xhr, textStatus, errorThrown) => {
            console.log(errorThrown);
        });
    }

    function handleClick(e) {
        const classes = {
            userActionsContainer: styles["user-actions-container"],
            userActions: styles["user-actions-item"]
        };

        const actionContainer = $(inputEl.current).find("." + classes.userActionsContainer);
        if (inputEl && inputEl.current.contains(e.target)) {
            if (!$(actionContainer).is(":visible")) {
                let offset = $(e.target).offset();

                $(actionContainer)
                    .fadeIn(50)
                    .css({
                        left: ((offset.left + $(e.target).innerWidth()) - $(actionContainer).outerWidth() - 10),
                        top: $("." + classes.userActions).outerHeight() //$(actionContainer).outerHeight()
                    });
            }
        }
        else {
            $(actionContainer).hide();
        }
    }

    function logOut() {
        $.ajax({
            url: "/account/logout",
            method: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify("/account/signinup")
        })
        .done((response) => {
            if (response.success) {
                window.location.href = response.redirectUrl;
            }
        })
        .fail((error) => {
            console.log(error.statusText);
        });
    }

    function hideActionContainer() {
        const classes = {
            userActionsContainer: styles["user-actions-container"]
        };

        const actionContainer = $(inputEl.current).find("." + classes.userActionsContainer);
        $(actionContainer).hide();
    }

    function goToAccountEdit() {
        window.location.href = "/user/accountedit";

        //hideActionContainer();
    }

    const classes = {
        userActionsContainer: styles["user-actions-container"],
        userActions: styles["user-actions-item"]
    };

    return (
        <div>
            <div styleName="topbar">
                <div styleName="topbar__section-user">
                    {
                        userName &&
                        <div styleName="topbar__user-greeting"><Icon.HandWaving styleName="hello-icon" weight="fill" /> Hello, {userName}!</div>
                    }
                    <div ref={inputEl}>
                        <span styleName="user-avatar" data-letters=""><Icon.User styleName="hello-icon" weight="fill" /> </span>
                        <div className={classes.userActionsContainer}>
                            <span className={classes.userActions} onClick={goToAccountEdit}>{"Account"}</span>
                            <span className={classes.userActions} onClick={logOut}>{"Log Out"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopBar;